export const getContextoAnswers = async (axios, config) => {
	return await axios
		.get(`${config.API_SERVICE}/v3/contexto`)
		.then((response) => {
			return response.status === 200 && response.data.status === 200
				? response.data
				: {};
		})
		.catch((err) => {
			console.error("Could not connect to Contexto API endpoint", err);
			return {};
		});
};
